module.exports = __webpack_public_path__ + "img/zhangyuying.e44dfc1d.jpg";